/* Lenny's Laundry — theme behaviour. Vanilla, no dependencies.
   Everything here is progressive enhancement: with JS off, the buy box is a
   normal product form that posts to /cart/add and the page reloads. */
(function () {
  'use strict';

  var T = window.LennysTheme || {};
  var money = T.moneyFormat || '${{amount}}';
  var strings = T.strings || {};

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return money
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  /* ---- status toast ---------------------------------------------------- */
  var statusEl;
  function status(text, href, label) {
    if (!statusEl) return;
    qs('[data-ll-status-text]', statusEl).textContent = text;
    var link = qs('[data-ll-status-link]', statusEl);
    if (href) { link.href = href; link.textContent = label || ''; link.hidden = false; }
    else { link.hidden = true; }
    statusEl.hidden = false;
    clearTimeout(status._t);
    status._t = setTimeout(function () { statusEl.hidden = true; }, 6000);
  }

  /* ---- cart count ------------------------------------------------------ */
  function refreshCartCount() {
    fetch((T.routes && T.routes.cart) ? T.routes.cart + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        qsa('[data-ll-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---- buy box --------------------------------------------------------- */
  function initBuyBox(root) {
    var dataEl = qs('[data-ll-product-data]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var form = qs('form[action*="/cart/add"]', root);
    var idInput = qs('[data-ll-variant-id]', root);
    var planInput = qs('[data-ll-plan-input]', root);
    var priceEl = qs('[data-ll-price]', root);
    var compareEl = qs('[data-ll-compare]', root);
    var stockEl = qs('[data-ll-stock]', root);
    var termsEl = qs('[data-ll-terms]', root);
    var freqEl = qs('[data-ll-frequency]', root);
    var button = qs('[data-ll-add]', root);
    var labelEl = qs('[data-ll-add-label]', root);

    function current() {
      var checked = qs('[data-ll-size]:checked', root);
      var id = checked ? checked.value : (idInput && idInput.value);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    function subscribeSelected() {
      var r = qs('[data-ll-mode]:checked', root);
      return !!r && r.value === 'subscribe';
    }

    function render() {
      var v = current();
      if (!v) return;

      if (idInput) idInput.value = v.id;

      // has_plans is product level but plans are per variant, so a variant can
      // be outside the plan. Subscribing to it is impossible: the selling_plan
      // input stays disabled and the order silently posts as a one-time
      // purchase. Fall back to one-time rather than show a subscribe UI that
      // does not subscribe.
      var planAvailable = !!(v.plans && v.plans.length);
      var sub = subscribeSelected();
      if (!planAvailable && sub) {
        var onceRadio = qs('[data-ll-mode][value="once"]', root);
        if (onceRadio) { onceRadio.checked = true; }
        sub = false;
      }
      var subRadio = qs('[data-ll-mode][value="subscribe"]', root);
      if (subRadio) { subRadio.disabled = !planAvailable; }

      // Rebuild the frequency options for this variant. Plan groups can differ
      // between variants, so carrying the previous variant's options over would
      // submit a plan that is not on offer for the one selected.
      if (freqEl) {
        var wanted = v.plans.map(function (pl) { return String(pl.id); }).join(',');
        if (freqEl.getAttribute('data-ll-plan-ids') !== wanted) {
          var keep = freqEl.value;
          freqEl.textContent = '';
          v.plans.forEach(function (pl) {
            var opt = document.createElement('option');
            opt.value = pl.id;
            opt.textContent = pl.name;
            freqEl.appendChild(opt);
          });
          freqEl.setAttribute('data-ll-plan-ids', wanted);
          if (keep && wanted.split(',').indexOf(String(keep)) !== -1) freqEl.value = keep;
        }
      }

      var planId = '';
      if (sub && planAvailable) {
        planId = freqEl && freqEl.value ? freqEl.value : v.plans[0].id;
        var match = null;
        for (var i = 0; i < v.plans.length; i++) {
          if (String(v.plans[i].id) === String(planId)) match = v.plans[i];
        }
        if (!match) { match = v.plans[0]; planId = match.id; }
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          compareEl.textContent = v.price > match.price ? formatMoney(v.price) : '';
          compareEl.hidden = !(v.price > match.price);
        }
      } else {
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          var showCompare = v.compare_at && v.compare_at > v.price;
          compareEl.textContent = showCompare ? formatMoney(v.compare_at) : '';
          compareEl.hidden = !showCompare;
        }
      }

      if (planInput) {
        planInput.value = planId;
        planInput.disabled = !planId;
      }
      if (freqEl) freqEl.hidden = !(sub && planAvailable && v.plans.length > 1);
      if (termsEl) termsEl.hidden = !sub;

      if (stockEl) {
        stockEl.textContent = v.stock_label || '';
        stockEl.hidden = !v.stock_label;
        stockEl.classList.toggle('ll-stock--low', !!v.stock_low);
      }

      if (button) {
        button.disabled = !v.available;
        if (labelEl) {
          labelEl.textContent = v.available
            ? (strings.add_to_cart || 'Add to cart')
            : (strings.sold_out || 'Sold out');
        }
      }
    }

    qsa('[data-ll-size],[data-ll-mode]', root).forEach(function (el) {
      el.addEventListener('change', render);
    });
    if (freqEl) freqEl.addEventListener('change', render);
    render();

    if (!form) return;
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (button) button.disabled = true;
      if (labelEl) labelEl.textContent = strings.adding || 'Adding…';

      fetch((T.routes && T.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            status((res.body && res.body.description) || strings.add_error || 'Could not add to cart.');
          } else {
            status(strings.added || 'Added to cart.',
              (T.routes && T.routes.cart) || '/cart',
              strings.view_cart || 'View cart');
            refreshCartCount();
          }
        })
        .catch(function () {
          status(strings.add_error || 'Could not add to cart.');
        })
        .then(function () {
          if (button) button.disabled = false;
          render();
        });
    });
  }

  /* ---- boot ------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    statusEl = qs('[data-ll-status]');
    qsa('[data-ll-buy]').forEach(initBuyBox);
  });

  document.addEventListener('shopify:section:load', function (event) {
    qsa('[data-ll-buy]', event.target).forEach(initBuyBox);
  });
})();
